import { Component, HostBinding, Input } from '@angular/core';

@Component({
	selector: 'ac-wizard-step',
	template: `<ng-content></ng-content>`
})
export class WizardStepComponent {
	@Input() public title: string;
	@Input() public nextButtonText: string = 'Next';
	@Input() public backButtonText: string = 'Back';
	@Input() public nextDisabledMessage: string;
	@Input() public isNextDisabled: boolean = false;
	@Input() public isPrevDisabled: boolean = false;
	public isSelected: boolean = false;
	@HostBinding('hidden')
	public get hidden(): boolean {
		return !this.isSelected;
	}

}
